import React from "react";
import "./Testimonial.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import { Pagination } from "swiper";
import "swiper/css/pagination";
import profilePic1 from "../../img/profile1.jpg";
import profilePic2 from "../../img/profile2.jpg";
import profilePic3 from "../../img/profile3.jpg";
import profilePic4 from "../../img/profile4.jpg";

const Testimonial = () => {
  const clients = [
    {
      img: profilePic1,
      review:
        "Was very happy to work with the Milon Das, Android Developer. He is very experienced and professionals in what he do, and worked very well to meet all of our needs, and he still do. If there is a problem I can be sure that He will do their best to solve it.",
    },
    {
      img: profilePic2,
      review:
        "We have worked with Milon Das over a sustained period of time. He is arguably one of the most professional, friendly, considerate and dedicated persion. I do strongly recommend the services of Milon Das, Android Developer",
    },
    {
      img: profilePic3,
      review:
        "It was pleasure working with Milon Das on a mobile app project for one of our clients. We faced many challenges and he always found a solution. The end-users of the app loved the results and we look forward to working with Him on any future projects.",
    },
    {
      img: profilePic4,
      review:
        "Milon Das is the best Developer which I have worked. He is able to deliver the task within the deadline. He is very knowledgeable about Modern app development programming and if there are any challenges he resolved in quick time. He always go above and beyond. I highly recommend to anyone in the India, Bangladesh who are looking to outsource to an excellent person.",
    },
  ];

  return (
    <div className="t-wrapper" id="testimonial">
      <div className="t-heading">
        <span>Clients always get </span>
        <span>Exceptional Work </span>
        <span>from me...</span>
      <div className="blur t-blur1" style={{ background: "var(--purple)" }}></div>
      <div className="blur t-blur2" style={{ background: "skyblue" }}></div>

      </div>
      <Swiper
        // install Swiper modules
        modules={[Pagination]}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {clients.map((client, index) => {
          return (
            <SwiperSlide key={index}>
              <div className="testimonial">
                <img src={client.img} alt="" />
                <span>{client.review}</span>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default Testimonial;
